// Pure state of the single load row of the connector import dialog (story 194, slice 2a).
// The row holds what the user typed; it is validated here and turned into the input of `buildConnectorOrder`.
import { isValidPriority } from './connectorOrder'

export const DEFAULT_PRIORITY = '5'
export const DEFAULT_PLAN_CODE = 'ASAP'
export const FABRICATION_ORDER_MAX_LENGTH = 60

/** Row at its initial values. Empty values are '' (the target date and the file included), never null. */
export const initialConnectorRow = () => ({
  code: '',
  targetDate: '',
  priority: DEFAULT_PRIORITY,
  clientCode: '',
  planCode: DEFAULT_PLAN_CODE,
  extendedValues: {},
  file: ''
})

const isRealDate = (value) => value instanceof Date && !Number.isNaN(value.getTime())

export const hasChosenFile = (row) => row.file !== ''

/** Initial value of an extended cell, by the type the creation row gives that column: a yes/no starts as false. */
export const initialExtendedValue = (column) => column.type === 'boolean' ? false : ''

/** V9: a mandatory extended column needs a non-blank value; a yes/no always has one. */
const extendedColumnFilled = (column, value) => {
  if (!column.mandatory || column.type === 'boolean') return true
  if (column.type === 'dateTimePicker') return isRealDate(value)
  return String(value ?? '').trim() !== ''
}

/**
 * V1-V4 and V9: whether the row can be sent. Client code and optional extended columns may stay empty.
 * @param {Object} row row as built by `initialConnectorRow`
 * @param {Array} extendedColumns columns of useGetExtendedColumns('fabrication_order')
 */
export const isRowComplete = (row, extendedColumns = []) => {
  if (row.code.trim() === '') return false
  if (!isRealDate(row.targetDate)) return false
  if (row.priority === '' || !isValidPriority(Number(row.priority))) return false
  if (!hasChosenFile(row)) return false
  return extendedColumns.every((column) => extendedColumnFilled(column, row.extendedValues[column.field]))
}

/** Input of `buildConnectorOrder` for a complete row. */
export const toOrderInput = (row) => ({
  code: row.code,
  targetDateMs: row.targetDate.getTime(),
  priority: Number(row.priority),
  clientCode: row.clientCode,
  planificationType: row.planCode,
  extendedValues: row.extendedValues
})
